/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Last ned i App Store",
      "Treff grupper i nærheten",
      "Bli kjent med nye folk i Hives.",
      "Finn din type mennesker",
      "Uansett hvilke interesser du har, er det en Hive for deg!",
      "Et trygt sted å være deg",
      "Velg mellom Skjulte eller Åpne Hives.",
      "Kom i gang",
      "Uansett hvilke interesser du har, er det en Hive for deg",
      "Bli kjent med nye mennesker i en Hive på Bumble BFF",
      "Du er invitert til Hives",
      "Møt nye grupper av lokale på Bumble BFF sin nye tjeneste, Hives. Lag din BFF-profil på Bumble-appen i dag.",
      "Få den i Google Play",
      "Administrer cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dager"
            ],
            "singular": [
                  "dag"
            ]
      },
      "hour": {
            "plural": [
                  "timer"
            ],
            "singular": [
                  "time"
            ]
      },
      "minute": {
            "plural": [
                  "minutter"
            ],
            "singular": [
                  "minutt"
            ]
      },
      "month": {
            "plural": [
                  "måneder"
            ],
            "singular": [
                  "måned"
            ]
      },
      "second": {
            "plural": [
                  "sekunder"
            ],
            "singular": [
                  "sekund"
            ]
      },
      "year": {
            "plural": [
                  "år"
            ],
            "singular": [
                  "år"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
